/** Wspólny korpus + końcówki FB (link) / IG (hasło ManyChat). Lustrzane stałe z carousel_caption_compose.py */

export const FB_SOFT_CTA = "👇 Jeśli chcesz dowiedzieć się więcej, kliknij w link poniżej.";
export const IG_KEYWORD_CTA = "🔥 Jeśli chcesz dowiedzieć się więcej, napisz „matka” w komentarzu.";

const VIA_RE = /https?:\/\/[^\s]*kasiazareba\.pl\/k\/[A-Za-z0-9_-]+/gi;
const IG_KEYWORD_LINE =
  /^(?:[🔥💬✨]\s*)?(?:Jeśli chcesz dowiedzieć się więcej,\s*napisz\s+(?:w komentarzu\s+hasło\s+)?[„"]?(?:matka|pakiet)[”"]?(?:\s+w komentarzu)?\.?|Napisz w komentarzu hasło\s+[„"]?(?:pakiet|matka)[”"]?\s*,?\s*a wyślę Ci link\.?)$/i;
const ORPHAN_LINK_LEAD =
  /^(?:Pakiet ebook[^\n]*znajdziesz tutaj:?|moje materiały znajdziesz tutaj:?|znajdziesz tutaj:?)\s*$/i;

export function stripPlatformEndings(text: string, viaUrl = ""): string {
  let body = String(text || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n").trim();
  if (!body) return "";
  const via = (viaUrl || "").trim().replace(/[.,;:)]+$/, "");
  if (via) body = body.split(via).join("");
  body = body.replace(VIA_RE, "");
  const lines: string[] = [];
  for (const line of body.split("\n")) {
    const s = line.trim();
    if (!s) {
      lines.push("");
      continue;
    }
    if (/^(?:[👇⬇️🔗➡️]\s*)?Jeśli chcesz dowiedzieć się więcej,\s*kliknij w link poniżej\.?$/i.test(s)) continue;
    if (IG_KEYWORD_LINE.test(s)) continue;
    if (/^Link\s*:\s*$/i.test(s)) continue;
    if (ORPHAN_LINK_LEAD.test(s)) continue;
    if (/^https?:\/\/[^\s]*kasiazareba\.pl\/k\/[A-Za-z0-9_-]+$/i.test(s)) continue;
    if (/znajdziesz tutaj:?\s*$/i.test(s) && !/http/i.test(s)) {
      let trimmed = s.replace(/[,.]?\s*(?:moje materiały\s+)?znajdziesz tutaj:?\s*$/i, "").trim();
      if (trimmed) {
        if (!/[.!?…]$/.test(trimmed)) trimmed += ".";
        lines.push(trimmed);
      }
      continue;
    }
    lines.push(line);
  }
  return lines.join("\n").replace(/\n{3,}/g, "\n\n").trim();
}

export function platformEnding(channel: "fb" | "ig", viaUrl = ""): string {
  if (channel === "ig") return IG_KEYWORD_CTA;
  const via = (viaUrl || "").trim();
  return via ? `${FB_SOFT_CTA}\n\n${via}` : FB_SOFT_CTA;
}

export function composeCaptionPreview(opts: {
  caption?: string;
  captionEngage?: string;
  hashtags?: string;
  shortUrl?: string;
  channel: "fb" | "ig";
}): string {
  const via = (opts.shortUrl || "").trim();
  const body = stripPlatformEndings(opts.caption || "", via);
  const ending = platformEnding(opts.channel, opts.channel === "fb" ? via : "");
  const parts = [body, ending, (opts.captionEngage || "").trim(), (opts.hashtags || "").trim()];
  return parts.filter(Boolean).join("\n\n");
}
